// 兼容 0.x的图表类型
export { default as Ring, RingConfig } from './ring';
export { default as GroupColumn, GroupColumnConfig } from './group-column';
export { default as GroupBar, GroupBarConfig } from './group-bar';
export { default as PercentageStackArea, PercentageStackAreaConfig } from './percentage-stack-area';
export { default as PercentageStackBar, PercentageStackBarConfig } from './percentage-stack-bar';
export { default as PercentageStackColumn, PercentageStackColumnConfig } from './percentage-stack-column';
export { default as StackArea, StackAreaConfig } from './stack-area';
export { default as StackBar, StackBarConfig } from './stack-bar';
export { default as StackColumn, StackColumnConfig } from './stack-column';
